
<template>
  <div style="width: 100%; height: 100%;">
    <div style="width: 100%; height: 50px; line-height: 50px; font-size: 20px; font-weight: bold; text-align: center; background-color: #E8E8E8;">
      PACKING & INVOICE
    </div>
    <div style="width: 100%; height: calc(100% - 100px); overflow-y: auto;">
      <div class="container text-left">
        <div class="row">
          <div class="col-6">
            Shipper / Exporter
            <input class="form-control" v-model="item.shipper" @change="saveItem"/>
            <textarea class="form-control" v-model="item.shipperAddress1" rows="4" placeholder="주소"  @change="saveItem"></textarea>
            <input class="form-control" v-model="item.shipperTel" @change="saveItem" placeholder="Tel" />
          </div>
          <div class="col-6">
            <b>No& Date of Invoice</b>
            <input class="form-control" type="date" v-model="item.invoiceDate" @change="saveItem"/>

            <b>Ref:</b>
            <input class="form-control" v-model="item.reference" @change="saveItem"/>

            <b>URN CODE:</b>
            <input class="form-control" v-model="item.urnCode" @change="saveItem"/>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            Consignee / Importer
            <input class="form-control" v-model="item.consignee" @change="saveItem"/>
            <textarea class="form-control" v-model="item.consigneeAddress1" @change="saveItem" rows="4" placeholder="Address"></textarea>
            <input class="form-control" v-model="item.consigneeTel" @change="saveItem" placeholder="Tel"/>
          </div>
          <div class="col-6">
<!--            Point and Country of Origin-->
<!--            <input class="form-control" v-model="item.pointCountryOfOrigin" @change="saveItem" placeholder="UNITED KINGDOM"/>-->
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            Notify Party
            <input class="form-control" v-model="item.notifyParty" @change="saveItem"/>
            <textarea class="form-control" v-model="item.notifyPartyAddress" @change="saveItem" rows="4" placeholder="Address"></textarea>
            <input class="form-control" v-model="item.notifyPartyTel" @change="saveItem" placeholder="Tel"/>
            <input class="form-control" v-model="item.notifyPartyEmail" @change="saveItem" placeholder="Email"/>
          </div>
          <div class="col-6">
            Remarks & Reference
            <textarea class="form-control" v-model="item.remarks" @change="saveItem" rows="4"></textarea>

            <br/><br/>
            <table style="width: 100%;">
              <tr>
                <td>Inco Terms</td>
                <td>
                  <input class="form-control" v-model="item.incoTerms" @change="saveItem" placeholder="Inco Terms"/>
                </td>
              </tr>
              <tr>
                <td>freight Charge</td>
                <td>
                  <input class="form-control" type="number" v-model="item.freightChargeFloat" @change="saveItem"/>
                </td>
              </tr>
            </table>

          </div>
        </div>
        <div class="row">
          <div class="col-3">
            Port of Loading
            <input class="form-control" v-model="item.pol" @change="saveItem"/>
          </div>
          <div class="col-3">
            Final Destination
            <input class="form-control" v-model="item.finalDestination" @change="saveItem"/>
          </div>
          <div class="col-6">
          </div>
          <div class="col-3">
            Vessel / Flight
            <input class="form-control" v-model="item.vessel" @change="saveItem"/>
          </div>
          <div class="col-3">
            Sailing on About
          </div>
          <div class="col-6">
          </div>




        </div>
        <div class="row" style="margin-top: 20px;">

          <div class="col-12">
            <table class="table">
              <tr>
                <th>Marks & Numbers</th>

                <th>Description</th>
                <th>Quantity</th>
                <th>GW</th>
                <th>Unit Price(GB)</th>
                <th>Total (GB)</th>
                <th></th>
              </tr>

              <tr>
                <td colspan="6" style="text-align: center;">
                  HS CODE: <input v-model="item.hsCode" @change="saveItem"/>
                </td>
              </tr>
              <tr v-for="good in item.goods" :key="'good-item-' + good.id">
                <td>
                  <input type="number" class="form-control" v-model="good.numberOfPackages" @change="saveItem"/>
                </td>
                <td>
                  <input class="form-control" v-model="good.title" @change="saveItem"/>
                </td>
                <td>
                  <input class="form-control" v-model="good.amount" @change="saveItem"/>
                </td>
                <td>
                  <input class="form-control" v-model="good.weightFloat" @change="saveItem"/>
                </td>
                <td>
                  <input class="form-control" v-model="good.priceFloat" @change="saveItem"/>
                </td>
                <td style="line-height: 38px;">
                  {{(good.totalPrice/100.0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                </td>
                <td><button class="btn btn-danger" @click="deleteGoogItem(good)"><i class="fas fa-trash"></i></button></td>
              </tr>
              <tr>
                <td colspan="7">
                  <button class="btn btn-primary" @click="addGoodItem">Add Item</button>
                </td>
              </tr>
              <tr style="font-weight: bold;">
                <td colspan="3">{{item.numberOfPackages}} C/T Boxes</td>
                <td>{{(item.grossWeight/100.0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                <td></td>
                <td>{{(item.totalPrice/100.0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
              </tr>

              <tr>
                <td>NET WEIGHT</td>
                <td><input type="number" v-model="item.netWeightFloat" class="form-control" @change="saveItem"/></td>
                <td colspan="4"></td>
              </tr>
              <tr>
                <td>GROSS WEIGHT</td>
                <td>{{item.grossWeightFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} KG</td>
                <td colspan="4"></td>
              </tr>
            </table>

          </div>
        </div>
        <div class="row" style="margin-top: 20px;">
          <div class="col-6">
          </div>
          <div class="col-6">
            <input v-model="item.signedBy" class="form-control" @change="saveItem"/>
            Singed By
          </div>
        </div>

      </div>
    </div>
    <div style="width: 100%; height: 50px; line-height: 50px; background-color: #E8E8E8; display: flex;">
      <div style="width: 50%; height: 50px; line-height: 50px;padding-right: 20px; padding-left: 20px; text-align: left;">
        <button class="btn btn-dark" v-on:click="closeItem">Close</button>
      </div>
      <div style="width: 50%; height: 50px; line-height: 50px;padding-right: 20px; padding-left: 20px; text-align: right;">
        <button class="btn btn-success" v-on:click="getExcel">Get Excel File</button>
        <button class="btn btn-danger" v-on:click="getPDF">Generate PDF</button>
        <button class="btn btn-primary" v-if="item.documentUrl !== null && item.documentUrl.length > 0" v-on:click="openPDF">View PDF</button>

        <button class="btn btn-success" v-on:click="saveItem">SAVE</button>
      </div>

    </div>
    <template v-if="pdfItem !== false">
      <transition name="slideup">
        <pdf-viewer
          :item="pdfItem"
          :on-close="closePdfViewer">

        </pdf-viewer>
      </transition>
    </template>
  </div>
</template>

<script>

import PdfViewer from "./PdfViewer.vue";
import DatePicker from "vue2-datepicker";
import {generateOrderNumber, millisToDate, showDialog} from "../api/utils";
import {getLadingPDF, updateHouse} from "../api/houses";
import {getPackingInvoicePDF, getPackingListExcel, updatePackingInvoice} from "../api/request";
import {deleteGood, updateGood} from "../api/goods";
import FileDownload from "js-file-download";
export default {
  name: 'PackingInvoiceView',
  data() {
    return {
      pdfItem:false,
    }
  },
  props: {
    request: {
      type:Object,
      default: function() {return null;}
    },
    item: {
      type:Object,
      default: function(){return null;}
    },
    onUpdated: {
      type:Function,
      default:null,
    },
    onClose: {
      type: Function,
      default:null,
    },
    onDeleted: {
      type: Function,
      default:null,
    },
    customers: {
      type: Array,
      default:() => [],
    }
  },
  components: {
    DatePicker,
    PdfViewer
  },
  created() {
  },
  mounted() {
    this.onLoaded();
  },
  methods: {
    dummy: function () {

    },
    onLoaded: function() {

    },
    openPDF: function() {
      console.log("open pdf");
      console.log(this.request);

      let date = millisToDate(new Date(), '-');
      let emailForm = {
        to: this.item.invoiceToEmail,
        subject:'Packing Invoice ' + ' ' + this.item.shipper + ' ' + date,
        body: '안녕하세요 UKO Shipping입니다.\n',
        documents:[{
          title:'Packing_Invoice-' + this.item.shipper + '-' + generateOrderNumber(),
          url:this.item.documentUrl,
        }]
      }
      this.$data.pdfItem = {
        url: this.item.documentUrl,
        title: "Packing-Invoice " + ' ' + this.item.shipper,
        emailForm: emailForm,
      }
    },
    closePdfViewer: function() {
      this.$data.pdfItem = false;
    },
    getExcel: function() {
      console.log("generate packing list");
      let timestamp = new Date().getTime();
      console.log(this.item);
      let fileName = "PackingList-" + this.item.id + '-' + timestamp + '.xlsx';
      getPackingListExcel(this.item.id)
        .then(function(response) {
          FileDownload(response.data, fileName);
        })
        .catch(function(err) {
          console.log(err);
          if(err.response !== undefined) {
            console.log(err.response);
          }
        })
    },
    getPDF() {
      let self = this;
      // const FileDownload = require('js-file-download');
      // let fileName = "HBL-"+ this.item.blNumber + "-" + this.item.shipperTitle + new Date().getTime() +'.pdf';
      getPackingInvoicePDF(this.item.id)
        .then(function(data) {
          if(data.success === true) {
            self.item.documentUrl = data.item.documentUrl;
            self.openPDF();
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
    closeItem: function() {
      if(this.onClose !== null) {
        this.onClose();
      }
    },
    deleteGoogItem: function(good) {
      let self = this;
      deleteGood(good.id)
        .then(function(data) {
          if(data.success === true) {
            for(let i = 0 ; i < self.item.goods.length ; i++) {
              if(self.item.goods[i].id === data.item.id) {
                self.item.goods.splice(i, 1);
                break;
              }
            }
            self.saveItem();
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
    addGoodItem: function() {
      let good = {
        id:0,
        type:'packing_invoice_item',
        packingInvoiceId:this.item.id,
        title:'',

      }
      let self = this;
      updateGood(good)
        .then(function(data) {
          if(data.success === true) {
            self.item.goods.push(data.item);
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
    saveItem: function() {
      let self = this;
      let totalCount = 0;
      let totalWeight = 0;
      let totalPrice = 0;
      if(this.item.goods !== null && this.item.goods.length > 0) {

        for(let i = 0 ; i < this.item.goods.length ; i++) {
          this.item.goods[i].weight = Math.round(parseFloat(this.item.goods[i].weightFloat) * 100);
          this.item.goods[i].price = Math.round(parseFloat(this.item.goods[i].priceFloat) * 100);
          this.item.goods[i].totalPrice = this.item.goods[i].price * this.item.goods[i].amount;
          if(this.item.goods[i].numberOfPackages !== null && this.item.goods[i].numberOfPackages !== '') {
            totalCount += parseInt(this.item.goods[i].numberOfPackages);
          }
          totalWeight += this.item.goods[i].weight;
          totalPrice += this.item.goods[i].totalPrice;
        }
      }
      this.item.numberOfPackages = totalCount;
      this.item.grossWeight = totalWeight;
      this.item.totalPrice = totalPrice;
      this.item.freightCharge = Math.round(parseFloat(this.item.freightChargeFloat)*100);
      this.item.netWeight = Math.round(parseFloat(this.item.netWeightFloat)*100);
      updatePackingInvoice(this.item)
        .then(function(data) {
          if(data.success === true) {
            if(self.onUpdated !== null) {
              self.onUpdated(data.item);
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PackingInvoiceView.vue